import action from './action.json';
import auth from './auth.json';
import common from './common.json';
import comparer from './comparer.json';
import dictionaries from './dictionaries.json';
import home from './home.json';
import jobOrderDetails from './jobOrderDetails.json';
import notification from './notification.json';

export const en = {
  common,
  action,
  home,
  dictionaries,
  jobOrderDetails,
  comparer,
  auth,
  notification,
};
